import { useEffect } from 'react';
import { formatEvent, trackPage } from '../components/Analytics';

const usePageView = page =>  {
  useEffect(() => {
      const mapRoutes = { '/':'home' }
      const suffix = 'us|en|corp|publicpages|'
      const event = mapRoutes[page] || formatEvent(page);
      trackPage(`${suffix}${event}`);
  }, [page]);
}

export default usePageView;

